<div class="relative">
  <!-- Label -->
  <label *ngIf="label" [for]="id" class="block mb-2 text-sm font-medium text-westetics-neutral-950">
    {{ label }}
  </label>

  <!-- Dropdown Button -->
  <button
    type="button"
    [id]="id"
    (click)="toggle()"
    [disabled]="disabled"
    class="w-full flex items-center justify-between px-3 py-2.5 rounded-[10px] border text-sm bg-white transition-colors"
    [ngClass]="{
      'border-westetics-purple-800 text-westetics-neutral-800 hover:bg-westetics-neutral-50 cursor-pointer': !disabled,
      'border-gray-300 bg-gray-100 text-gray-400 cursor-not-allowed': disabled
    }"
    aria-haspopup="listbox"
    [attr.aria-expanded]="isOpen"
  >
    <span class="text-left" [ngClass]="{'text-gray-400': !selectedValue}">
      {{ displayLabel }}
    </span>
    <!-- Arrow icon -->
    <svg 
      class="ml-2 w-4 h-4 flex-shrink-0 transition-transform duration-200" 
      [ngClass]="{'rotate-180': isOpen}"
      viewBox="0 0 20 20" 
      fill="none" 
      xmlns="http://www.w3.org/2000/svg" 
      aria-hidden="true"
    >
      <path d="M9.99956 10.879L13.7121 7.1665L14.7726 8.227L9.99956 13L5.22656 8.227L6.28706 7.1665L9.99956 10.879Z" fill="#99A0AE"/>
    </svg>
  </button>

  <!-- Options Panel -->
  <ul 
    *ngIf="isOpen" 
    role="listbox" 
    class="absolute z-50 left-0 mt-2 w-full bg-white border border-gray-200 rounded-lg shadow-lg max-h-56 overflow-auto py-1"
  >
    <li 
      *ngFor="let option of options" 
      role="option" 
      (click)="selectOption(option)" 
      class="px-3 py-2 cursor-pointer text-sm transition-colors flex items-center gap-2"
      [ngClass]="{
        'bg-westetics-purple-600 text-white': selectedValue === option.value,
        'hover:bg-westetics-purple-600 hover:text-white text-westetics-neutral-800': selectedValue !== option.value
      }"
    >
      <span>{{ option.label }}</span>
    </li>
    
    <!-- Empty state -->
    <li *ngIf="options.length === 0" class="px-3 py-2 text-sm text-gray-400 text-center">
      Nenhuma opção disponível
    </li>
  </ul>
</div>
